<button
  type="button"
  class="document-action print-action"
  (click)="printDocument()"
>
  {{ 'ACTION.PRINT' | translate }}
</button>
